import { Field } from "react-final-form";
import { AiOutlineInfoCircle } from "react-icons/ai";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import { INBOX_OWNER, type InboxOwner } from "../../../api/connectionHub.types";
import styles from "./InboxOwnerToggle.module.scss";

export interface InboxOwnerToggleProps { ownerName: string; email: string; disabled?: boolean; }

const OPTIONS: Array<{ value: InboxOwner; label: string }> = [
  { value: INBOX_OWNER.OWN, label: "My Own" },
  { value: INBOX_OWNER.DELEGATE, label: "Someone Else's" },
];

export const InboxOwnerToggle = ({ ownerName, email, disabled = false }: InboxOwnerToggleProps): JSX.Element => (
  <Field<InboxOwner | undefined> name={ownerName}>{({ input, meta }) => (
    <fieldset className={styles.fieldset}>
      <legend>Whose inbox is this?</legend>
      <div className={styles.options}>
        {OPTIONS.map((option) => (
          <MeritoButton
            key={option.value}
            type="secondary-2"
            hover={false}
            btnText={option.label}
            className={input.value === option.value ? styles.optionSelected : ""}
            ariaSelected={input.value === option.value}
            disabled={disabled}
            onClick={() => { input.onChange(option.value); input.onBlur(); }}
          />
        ))}
      </div>
      {meta.touched && meta.error ? <span className={styles.error}>{meta.error}</span> : null}
      {input.value === INBOX_OWNER.DELEGATE && email.trim() ? (
        <p className={styles.note}>
          <AiOutlineInfoCircle aria-hidden="true" />
          <span>We'll email a setup link to {email.trim()} which expires in 24 hours.</span>
        </p>
      ) : null}
    </fieldset>
  )}</Field>
);

export default InboxOwnerToggle;
